module.exports = __webpack_public_path__ + "static/media/ic_invest_nfo.e3f4b452.svg";